import { API_CONFIG } from "../config/api";
import apiService from "./api";

// Client-specific API methods using Amplify API v6 REST
export const userApi = {
    // Get all clients
    getUser: async () => {
        return apiService.get(API_CONFIG.ENDPOINTS.ADMIN_ME);
    },
  };